const routerFR = {
    "releases": {
        "view": {
            "name": "Sorties",
            "buttonText": "Ajouter une nouvelle sortie",
            "secondaryButtonText": "Transférer la sortie",
            "headerText": "Sorties"
        },
        "add": {
            "name": "Ajouter une nouvelle sortie",
            "headerText": "Sorties"
        },
        "update": {
            "name": "Mettre à jour la sortie",
            "headerText": "Sorties"
        },
        "details": {
            "name": "Détails de la sortie",
            "headerText": "Sorties"
        },
        "transfer": {
            "name": "Transférer la sortie",
            "headerText": "Sorties"
        },
        "tracks": {
            "name": "Liste des pistes",
            "headerText": "Sorties"
        },
        "deliveryConfirmation": {
            "name": "Liste livrée",
            "headerText": "Liste livrée"
        },
        "storeDeliveryList": {
            "name": "Liste de livraison en magasin",
            "headerText": "Liste de livraison en magasin"
        }
    },
    "copyrightInfringements": {
        "view": {
            "name": "Infractions au droit d'auteur",
            "headerText": "Infractions au droit d'auteur"
        }
    },
    "escrowWallet": {
        "view": {
            "name": "Portefeuille séquestre",
            "headerText": "Portefeuille séquestre"
        }
    },
    "artists": {
        "view": {
            "name": "Artistes",
            "buttonText": "Ajouter un nouvel artiste",
            "headerText": "Artistes"
        },
        "add": {
            "name": "Ajouter un nouvel artiste",
            "headerText": "Artistes"
        },
        "update": {
            "name": "Mettre à jour l'artiste",
            "headerText": "Artistes"
        },
        "viewDetails": {
            "name": "Voir les détails de l'artiste",
            "headerText": "Voir les détails de l'artiste"
        },
        "wishlist": {
            "name": "Liste de souhaits des artistes",
            "headerText": "Liste de souhaits des artistes"
        },
        "addFromWishlist": {
            "name": "Ajouter un artiste de la liste de souhaits",
            "headerText": "Ajouter un artiste de la liste de souhaits"
        }
    },
    "trends": {
        "view": {
            "name": "Tendances",
            "headerText": "Tendances"
        }
    },
    "earningsDrilldown": {
        "view": {
            "name": "Gains",
            "headerText": "Détail des gains"
        }
    },
    "accounting": {
        "view": {
            "name": "Comptabilité intelligente",
            "headerText": "Comptabilité intelligente",
            "buttonText": "Ajouter une nouvelle comptabilité"
        },
        "add": {
            "name": "Ajouter une nouvelle comptabilité",
            "headerText": "Ajouter une nouvelle comptabilité"
        },
        "breakdown": {
            "name": "Répartition comptable",
            "headerText": "Répartition comptable"
        }
    },
    "invoices": {
        "view": {
            "name": "Factures",
            "headerText": "Factures",
            "buttonText": "Ajouter une facture"
        },
        "add": {
            "name": "Ajouter une facture",
            "headerText": "Ajouter une facture"
        }
    },
    "musicLink": {
        "view": {
            "name": "Lien musical",
            "buttonText": "Ajouter un nouveau lien musical",
            "headerText": "Lien musical",
            "secondaryButtonText": "URL du lien musical"
        },
        "add": {
            "name": "Ajouter un lien musical",
            "headerText": "Lien musical"
        },
        "update": {
            "name": "Mettre à jour le lien musical",
            "headerText": "Lien musical"
        },
        "viewStats": {
            "name": "Statistiques de vue du lien musical",
            "headerText": "Statistiques de vue du lien musical"
        }
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Partie URL du lien musical",
            "buttonText": "Ajouter une nouvelle partie URL du lien musical",
            "headerText": "Partie URL du lien musical"
        },
        "add": {
            "name": "Ajouter une nouvelle partie URL du lien musical",
            "headerText": "Partie URL du lien musical"
        },
        "update": {
            "name": "Mettre à jour la partie URL du lien musical",
            "headerText": "Partie URL du lien musical"
        }
    },
    "linkLandingPage": {
        "view": {
            "name": "Page de destination du lien",
            "buttonText": "Ajouter une page de destination du lien",
            "headerText": "Page de destination du lien"
        },
        "add": {
            "name": "Ajouter une page de destination du lien",
            "headerText": "Page de destination du lien"
        },
        "update": {
            "name": "Mettre à jour la page de destination du lien",
            "headerText": "Page de destination du lien"
        },
        "viewAnalytics": {
            "name": "Analytique de la page de destination du lien",
            "headerText": "Page de destination du lien"
        }
    },
    "mastering": {
        "view": {
            "name": "Mastering",
            "buttonText": "Ajouter un mastering",
            "headerText": "Mastering audio"
        },
        "add": {
            "name": "Ajouter un mastering",
            "headerText": "Mastering audio"
        },
        "update": {
            "name": "Mettre à jour le mastering",
            "headerText": "Mastering audio"
        },
        "viewSongs": {
            "name": "Chansons de mastering audio",
            "headerText": "Chansons de mastering audio"
        }
    },
    "featureRequest": {
        "view": {
            "name": "Demande de fonctionnalité",
            "buttonText": "Nouvelle demande de fonctionnalité",
            "headerText": "Demande de fonctionnalité"
        },
        "add": {
            "name": "Ajouter une demande de fonctionnalité",
            "headerText": "Demande de fonctionnalité"
        }
    },
    "scWhitelist": {
        "view": {
            "name": "Liste blanche SC",
            "headerText": "Liste blanche SC"
        }
    },
    "profile": {
        "view": {
            "name": "Profil",
            "headerText": "Mon profil"
        }
    },
    "announcements": {
        "view": {
            "name": "Annonces",
            "headerText": "Annonces"
        }
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Authentification à deux facteurs",
            "headerText": "Authentification à deux facteurs"
        }
    },
    "completeYourInformation": {
        "view": {
            "name": "Complétez vos informations",
            "headerText": "Complétez vos informations"
        }
    },
    "tokens": {
        "view": {
            "name": "Jetons",
            "headerText": "Jetons"
        }
    },
    "orderTokens": {
        "view": {
            "name": "Commander des jetons",
            "headerText": "Commander des jetons"
        }
    },
    "accessKeys": {
        "view": {
            "name": "Clés d'accès",
            "headerText": "Clés d'accès"
        }
    },
    "paymentMethods": {
        "view": {
            "name": "Méthodes de paiement",
            "buttonText": "Ajouter une méthode de paiement",
            "headerText": "Mes méthodes de paiement"
        },
        "add": {
            "name": "Ajouter une méthode de paiement",
            "headerText": "Mes méthodes de paiement"
        },
        "update": {
            "name": "Mettre à jour la méthode de paiement",
            "headerText": "Mes méthodes de paiement"
        }
    },
    "orderCredits": {
        "view": {
            "name": "Commander des crédits",
            "headerText": "Commander des crédits"
        }
    },
    "purchaseHistory": {
        "view": {
            "name": "Historique des achats",
            "headerText": "Historique des achats"
        }
    },
    "subscription": {
        "view": {
            "name": "Mon abonnement",
            "headerText": "Mon abonnement"
        },
        "upgrade": {
            "name": "Améliorer l'abonnement",
            "headerText": "Améliorer l'abonnement"
        }
    },
    "subUsers": {
        "view": {
            "name": "Sous-utilisateurs",
            "buttonText": "Ajouter un nouveau sous-utilisateur",
            "headerText": "Mes sous-utilisateurs"
        },
        "add": {
            "name": "Ajouter un nouveau sous-utilisateur",
            "headerText": "Mes sous-utilisateurs"
        },
        "edit": {
            "name": "Modifier le sous-utilisateur",
            "headerText": "Mes sous-utilisateurs"
        }
    },
    "labels": {
        "view": {
            "name": "Labels",
            "buttonText": "Ajouter un nouveau label",
            "headerText": "Mes labels"
        },
        "add": {
            "name": "Ajouter un nouveau label",
            "headerText": "Mes labels"
        },
        "edit": {
            "name": "Modifier le label",
            "headerText": "Mes labels"
        }
    },
    "statements": {
        "view": {
            "name": "Déclarations",
            "headerText": "Déclarations financières"
        }
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Déclarations des sous-utilisateurs",
            "headerText": "Déclarations des sous-utilisateurs"
        },
        "viewSubuser": {
            "name": "Déclarations de l'utilisateur",
            "headerText": "Déclarations de l'utilisateur"
        }
    },
    "dashboard": {
        "view": {
            "name": "Page d'accueil",
            "headerText": "Page d'accueil"
        }
    }
};

export default routerFR;